/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ex_IntroInputs */

const en_to_yaml_ex_intro = /** @type {(inputs: To_Yaml_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note which strings end up quoted and which do not.`)
};

const ko_to_yaml_ex_intro = /** @type {(inputs: To_Yaml_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 문자열이 인용되고 어떤 것이 인용되지 않는지 보세요.`)
};

const ja_to_yaml_ex_intro = /** @type {(inputs: To_Yaml_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの文字列が引用され、どれが引用されないかを見てください。`)
};

/**
* | output |
* | --- |
* | "Note which strings end up quoted and which do not." |
*
* @param {To_Yaml_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ex_intro = /** @type {((inputs?: To_Yaml_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ex_intro(inputs)
	if (locale === "ko") return ko_to_yaml_ex_intro(inputs)
	return ja_to_yaml_ex_intro(inputs)
});